var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOv3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 241,
    viewBox: "0 0 238 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_84)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5108 145.56C60.0034 134.908 62.8947 122.326 71.718 114.81C81.4692 106.504 95.6855 106.405 105.548 114.199C110.007 112.85 114.327 110.916 118.589 108.689L121.649 106.847C121.195 98.5189 124.724 90.2186 131.243 84.8683C145.925 72.8188 168.048 79.4585 173.711 97.5826C177.398 109.383 172.237 122.331 161.639 128.518L161.556 128.566L161.47 128.609L158.972 129.861L158.669 130.013L158.34 130.094C158.103 130.152 157.836 130.243 157.444 130.389C157.185 130.485 156.829 130.623 156.449 130.753L156.064 130.879C147.268 133.607 137.569 131.384 130.718 125.434C130.645 125.462 130.589 125.482 130.557 125.494L130.556 125.495C125.306 127.542 120.249 130.386 115.659 133.735C115.661 133.753 115.663 133.771 115.665 133.789C115.671 133.866 115.681 133.991 115.685 134.115L115.685 134.116C115.967 143.132 111.788 151.757 104.28 156.952C103.92 157.201 103.513 157.448 103.284 157.592C103.009 157.765 102.848 157.875 102.729 157.972L102.471 158.183L102.173 158.333L99.8219 159.512L99.4904 159.677L99.1281 159.757C99.0264 159.78 98.8798 159.827 98.5967 159.936C98.3765 160.021 97.9254 160.205 97.5153 160.341L97.5146 160.34C86.772 163.901 74.8093 160.279 67.9148 151.248L67.8788 151.2L67.8442 151.152L66.1143 148.688L65.9468 148.448L65.8282 148.181C65.6924 147.876 65.5203 147.558 65.2738 147.1C65.0506 146.686 64.7566 146.141 64.5108 145.56Z",
    fill: "#2E518E",
    stroke: "#FAFAFA",
    strokeWidth: 6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_84",
    x: 59.4083,
    y: 75.7725,
    width: 121.489,
    height: 94.9207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_84",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 132,
    fill: "white",
    transform: "translate(0 150.006) rotate(-46.7342)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOv3);
export default __webpack_public_path__ + "static/media/icon-ov-3.053326b027c87bd507fd0c1828a92482.svg";
export { ForwardRef as ReactComponent };